import store from "@/store/store";

export default {
    SET_USERS(state, users) {
        state.users = users
    },
    SET_PAGINATED_USER(state, { concatResults, users, setInInternal = false}) {
        const variable = setInInternal ? 'internalUsers' : 'users';

        if (concatResults) {
            state[variable] = [
                ...state[variable],
                ...users
            ]
        } else {
            state[variable] = users
        }
    },
    ADD_USER(state, user) {
        state.users.unshift(user)
    },
    UPDATE_USER(state, user) {
        const userIndex = state.users.findIndex((u) => u.id === user.id)
        if (userIndex !== -1 && state.users[userIndex]) {
            Object.assign(state.users[userIndex], user);
        }
    },
    DELETE_USER(state, userId) {
        const ItemIndex = state.users.findIndex((u) => u.id === userId)
        state.users.splice(ItemIndex, 1)
    },
    SET_ORIGINAL_USER_BEARER(state, bearer) {
        state.userInfos.originalBearer = bearer
    },
    SET_ORIGINAL_USER(state, user) {
        const bearer = state.userInfos.originalBearer
        state.userInfos = user
        state.userInfos.originalBearer = bearer
        state.isOriginalUser = false
    },
    SET_UNSEEN_MESSAGES(state, {userId, increments}) {
        const internalIndex = state.internalUsers.findIndex((c) => c.id === userId)

        if (internalIndex !== -1) {
            state.internalUsers[internalIndex].unseenMsg = increments ? state.internalUsers[internalIndex].unseenMsg + 1 : 0;
        } else {
            const userIndex = state.users.findIndex((c) => c.id === userId)
            if (userIndex !== -1) {
                let user = state.users[userIndex];
                user.unseenMsg = 1

                state.internalUsers = [
                    ...state.internalUsers,
                    ...[user]
                ]
            } else {
                store.dispatch("user/fetchPaginated", {
                    id: userId,
                    concatResults: true,
                    setInInternal: true,
                    pagination_page: 1,
                    pagination_limit: 1,
                }).then(() => {
                    store.dispatch('user/setUnseenMessages', {userId: userId, increments: true})
                })
            }
        }

        if (increments) {
            const user = state.internalUsers.splice(internalIndex, 1)[0];
            state.internalUsers.unshift(user);
        }
    }
}
